import { render } from "./HomeTheBest.vue?vue&type=template&id=4ea12d7c&scoped=true&ts=true"
import script from "./HomeTheBest.vue?vue&type=script&lang=ts"
export * from "./HomeTheBest.vue?vue&type=script&lang=ts"

import "./HomeTheBest.vue?vue&type=style&index=0&id=4ea12d7c&scoped=true&lang=scss"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea12d7c"]])

export default __exports__